import { ReactNode } from 'react';
import { ConfiguratorResultData } from '../../types';
import { ConfiguratorDataContext } from './configurator-data.context';

interface ConfiguratorDataProviderProps {
	children: ReactNode;
	data?: ConfiguratorResultData;
}

export const ConfiguratorDataProvider = ({ children, data }: ConfiguratorDataProviderProps) => {
	return (
		<ConfiguratorDataContext.Provider value={{ data }}>
			{children}
		</ConfiguratorDataContext.Provider>
	);
};
